import {
    AssetType,
    IAssetValue,
} from '@components';
import {
    IAsset,
    IAssetRobot,
    IAssetType,
} from '@models';

export const newRobotAssetFor = (type: IAssetType, asset: Partial<IAssetRobot> = {}, credentialStoreId?: number): IAssetRobot =>
    ({
        id: asset.id == null ? -1 : asset.id,
        robotId: asset.robotId == null ? -1 : asset.robotId,
        type: type,
        stringValue: '',
        boolValue: false,
        intValue: undefined,
        credentialUsername: '',
        credentialPassword: '',
        credentialStoreId,
        externalName: '',
        robotName: asset.robotName || '',
        value: undefined,
    });

export const getValueFor = (asset: IAsset | IAssetRobot, readonly?: boolean): IAssetValue | undefined | null => {
    switch (asset.type) {
        case AssetType.Bool:
            return !!asset.boolValue;
        case AssetType.Credential:
            return readonly ? asset.externalName || '' : {
                username: asset.credentialUsername || '',
                password: asset.credentialPassword || '',
            };
        case AssetType.Integer:
            return asset.intValue == null ? null : `${asset.intValue}`;
        case AssetType.Text:
            return asset.stringValue;
    }
    throw new Error(`getValueFor unknown asset type '${asset.type}'`);
};

export const generatePayloadFrom = (
    base: IAsset | IAssetRobot,
    type: IAssetType,
    model: any,
    readonly?: boolean): IAsset | IAssetRobot => {
    const payload = {
        id: base.id,
        type: type,
        robotId: base.robotId,
        credentialStoreId: base.credentialStoreId,
    } as IAsset;
    switch (type) {
        case AssetType.Bool:
            payload.boolValue = model;
            break;
        case AssetType.Credential:
            if (readonly) {
                payload.externalName = (model || '').trim();
                break;
            }
            payload.credentialUsername = (model.username || '').trim();
            if (!!model.password) {
                payload.credentialPassword = model.password;
            }
            break;
        case AssetType.Integer:
            if (model != null) {
                payload.intValue = parseInt(model, 10);
            }
            break;
        case AssetType.Text:
            payload.stringValue = (model || '').trim();
            break;
    }
    return payload;
};
